<template>
  <div class="text-start">
    <!--training title-->
    <v-row no-gutters class="mb-2">
      <v-col>
        <LocalisedContentEditable
          :values="trainingTitle"
          @update:values="values => (this.trainingTitle = values)"
          :placeholder="$t('course.courseDetails.courseNameHere')"
          :editable="isEditing"
          css-class="text-h4 font-weight-bold textLight--text"
          :hasError="training.hasInvalidTitle"
          :selectedLocale="selectedLocale"
        />
      </v-col>
    </v-row>

    <!--training trainer name and avatar-->
    <v-row no-gutters>
      <v-col>
        <template v-if="trainerNameAndAvatar">
          <v-avatar
            v-if="trainerNameAndAvatar.avatar"
            width="30"
            height="30"
            min-width="30"
            class="me-2"
          >
            <img :src="getImage(trainerNameAndAvatar.avatar)" alt="" />
          </v-avatar>

          <span
            v-if="trainerNameAndAvatar.name"
            class="me-2 caption font-weight-regular textLight--text"
          >
            {{ trainerNameAndAvatar.name }}
          </span>
        </template>

        <template v-if="trainingCreatedDate">
          <v-icon color="primary" class="me-2"> mdi-calendar-month </v-icon>

          <span class="caption font-weight-regular primary--text">
            {{ trainingCreatedDate }}
          </span>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";

export default {
  name: "CourseTitle",
  components: { LocalisedContentEditable },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    selectedLocale: {
      type: String,
      default: "en",
    },
  },
  computed: {
    trainingTitle: {
      get() {
        return this.training.title;
      },
      set(value) {
        this.$emit("update:training", {
          ...this.training,
          title: value,
          hasChangesInTitle: true,
          hasInvalidTitle: !value?.find(x => x.value?.trim()?.length),
        });
      },
    },
    trainerNameAndAvatar() {
      // return this.training.createdBy?._id !==
      //   this.$store.state.authenticatedUser?._id &&
      //   this.training.createdBy?.role === "EMPLOYEE"
      //   ? {
      //       name: this.training.createdBy.firstName,
      //       avatar: this.training.createdBy.avatar,
      //     }
      //   : null;

      return this.training.createdBy?._id != null
        ? {
            name: this.training.createdBy.firstName,
            avatar: this.training.createdBy.avatar,
          }
        : null;
    },
    trainingCreatedDate() {
      let formattedDate;

      if (
        this.training.createdBy?.role === "EMPLOYEE" &&
        this.training.appliedAt
      ) {
        formattedDate = `${this.$t("course.courseDetails.appliedOn")} `;
        formattedDate += this.$moment(parseInt(this.training.appliedAt)).format(
          "DD MMM YYYY"
        );
      } else if (
        this.training.createdBy?.role === "ADMIN" &&
        this.training.createdAt
      ) {
        formattedDate = this.$moment(parseInt(this.training.createdAt)).format(
          "DD MMM YYYY"
        );
      }

      return formattedDate;
    },
  },
};
</script>

<style lang="scss" scoped />
